import { Injectable } from "@angular/core";
import { CoreHttpClient } from "@obg/ngx.core";
import { Observable } from "rxjs";

import { BalanceLimitConfigService } from "./balance-limit.config";
import { BalanceLimitState, BalanceLimitUpdate } from "./balance-limit.model";

@Injectable({
	providedIn: "root",
})
export class BalanceLimitService {
	constructor(
		private httpClient: CoreHttpClient,
		private config: BalanceLimitConfigService
	) {}

	get(): Observable<BalanceLimitState> {
		return this.httpClient.get<BalanceLimitState>({
			url: this.config.getBalanceLimitEndpoint(),
		});
	}

	update(params: BalanceLimitUpdate): Observable<void> {
		return this.httpClient.post<void>({
			url: this.config.getBalanceLimitEndpoint(),
			data: params,
		});
	}
}
